module.exports = ".severity-box{\n    box-shadow: 6px 7px 15px 0px rgba(153,147,153,1);\n     padding: 1%\n}\n.mar-left{\n    margin-left: 2%\n}"